<template>
  <div class="table-responsive py-5 px-6">
    <div class="d-flex w-50 mb-5 justify-content-between align-items-center">
      <input type="text" placeholder="Entrez ici le nom du tableau" class="form-control form-control-solid text-center"  v-model="table.name" required/>
    </div>

    <table class="formality table-rounded table table-bordered mb-10">
      <thead class="position-relative">
      <tr class="fw-bold fs-6 text-gray-800">
        <th v-for="(column, key) in table.columns" :key="key" class="text-center fw-boldest fs-4 px-6 position-relative">
          <input type="text" placeholder="Entrez ici le nom de la colonne" class="form-control form-control-solid text-center"  v-model="column.name" required/>
          <button
              class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
              type="button"
              style="top: -12px; right: -15px; z-index: 1;"
              @click="deleteColumn(table, key)"
              title="Supprimer cette colonne"
          >
            <i class="fas fa-trash p-0 text-danger"></i>
          </button>
          <button
              class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
              type="button"
              style="bottom: -12px; right: -15px; z-index: 1;"
              @click="addColumn(table, key)"
              title="Ajouter une colonne"
          >
            <i class="fas fa-plus p-0 text-primary"></i>
          </button>
        </th>
      </tr>
        <button
            class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
            type="button"
            style="bottom: -12px; left: -15px; z-index: 1;"
            @click="addLine(table)"
            title="Ajouter une ligne"
            v-if="!table.lines?.length"
        >
          <i class="fas fa-plus p-0 text-primary"></i>
        </button>
      </thead>
      <tbody>
      <tr v-for="(line, lineKey) in table.lines" class="fw-bold fs-6 text-gray-800 position-relative">
        <td v-for="(column, key) in table.columns" :key="key" class="text-center px-4">
          <input type="text" placeholder="Entrez la valeur" class="form-control form-control-solid text-center"  v-model="line[key]" required/>
        </td>
        <button
            class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
            type="button"
            style="bottom: -12px; right: -15px; z-index: 1;"
            @click="deleteLine(table, lineKey)"
            title="Supprimer cette ligne"
        >
          <i class="fas fa-trash p-0 text-danger"></i>
        </button>
        <button
            class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
            type="button"
            style="bottom: -12px; left: -15px; z-index: 1;"
            @click="addLine(table, lineKey)"
            title="Ajouter une ligne"
        >
          <i class="fas fa-plus p-0 text-primary"></i>
        </button>
      </tr>
      </tbody>

    </table>

    <div class="d-flex justify-content-end">
      <Button v-if="$can( abilities.EDIT_PROJECT_FORMALITIES)" @click.prevent="saveTable(table, tableKey)" type="button" btn-class="btn-sm btn-primary me-2" btn-text="Enregistrer la modification" size="7px 30px"></Button>
      <Button @click.prevent="cancelTableModification(table, tableKey)" type="button" btn-class="btn-sm btn-default text-black me-2" btn-text="Annuler la modification" size="7px 30px"></Button>
    </div>
  </div>
</template>

<script setup>
  import Button from "@/components/Button.vue";
  import abilities from "@/composables/abilities";
  const props = defineProps({
    table: {
      type: Object,
      required: true
    },
    addLine: {
      type: Function,
      required: true
    },
    saveTable: {
      type: Function,
      required: true
    },
    deleteColumn: {
      type: Function,
      required: true
    },
    addColumn: {
      type: Function,
      required: true
    },
    tableKey: {
      required: true
    },
    deleteLine: {
      type: Function,
      required: true
    },
    cancelTableModification: {
      type: Function,
      required: true
    }
  })
</script>

<style scoped>
.formality.table {
  --bs-table-color: #212529;
  --bs-table-bg: transparent;
  --bs-table-border-color: #dee2e6;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #212529;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #212529;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #212529;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
  border-collapse: collapse;
}

.border_button_light {
  border: 1px solid #dee2e6 !important;
}

.formality.table-bordered > :not(caption) > * {
  border-width: 1px 1px;
  border-style: solid;
  border-color: var(--bs-table-border-color);
}

.formality.table-bordered th,
.formality.table-bordered td {
  border: 1px solid #dee2e6;
}

.formality.table-bordered tbody tr:last-child {
  border-bottom: 1px solid var(--bs-table-border-color) !important;
}

.table_button {
  opacity: 0;
}

.formality:hover .table_button{
  opacity: 1;
}

.table_button:hover {
  opacity: 1 !important;
}

</style>